export default __webpack_public_path__ + "static/values2-ec080dc761b5df2bc3f6d3c3c51f5277.webp";